// Author - Atul Pandey
// First Created - 11 Apr 2025
// Purpose - to provide points for logging

export const POINTS_CONFIG = {
    Action: {
      created: (details) => details.progress || 0, // 🆕 action gets initial progress as points
      moved: (details) =>
        // (details.updatedProgress ?? 0) - (details.previousProgress ?? 0), // delta progress
        (details.updatedProgress ?? 0), // latest progress
      accomplished: () => 100, // full action completion
    },
    Gratitude: {
      created: () => 10,
    },
    Reflection: {
      created: () => 10,
    },
    Creation: {
      created: () => 30,
    },
    Conversation: {
      created: () => 10,
    },
    Challenge: {
      created: () => 15,
    },
    Contribution: {
        created: () => 15,
    },
    Impact: {
      created: () => 20,
    },
    Win: {
      created: () => 25,
    },
    Intention: {
      created: () => 5,
    },
  };
  